/** @format */

const Portfolio = () => {
  return (
    <section class="portfolio-section" id="portfolio-scroll">
      <h1 class="h1-style">Works</h1>

      <h2>Apps</h2>

      <div class="articles">
        <div id="apps">
          
          <article class="one_box"> 
            <div id="works-described">
              <h3>Tip App</h3>

  {/*
              <b>
                <p>Summary</p>
              </b>
*/}
              <h5>
               Created a fast, user-friendly tip calculator using JavaScript, jQuery, and CSS, 
    helping restaurant-goers save time and effortlessly calculate tips.

              </h5>
            </div>


           <p><b>Click below to see code and app:</b> </p> 


            
            {/*TIPS*/}

            <div id="works-btns">

          
              <a
                href="https://app-tips.netlify.app"
                target="_blank"
                rel="noreferrer noopener"
              >
                
                  Site | {'<>'}
                

              </a>

              <a
                href="https://github.com/MRCODES/Tip-Calculator-by-MR"
                target="_blank"
                rel="noreferrer noopener"
              >
               Code{'<>'}
              </a>
            </div>


          </article>




          {/*SCORE*/}

          <article class="two_box">
            <div id="works-described">
              <h3>Score Keeper</h3>
            
            
              <h5>
           Designed an interactive, visually engaging digital chalkboard app that 
            allows users to create and reset content easily.  
                  <br></br>
<br></br>
              Built with React and CSS, the app features a themed chalk font and a reset button, 
              providing a smooth, intuitive experience that makes experimenting 
              and drawing on the board effortless and enjoyable.

            
                
      
                  
              </h5>
            </div>

                    <p><b>Click below to see code and app:</b> </p> 

            <div id="works-btns">
            
                <a
                  href="https://react-score-keeper.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Site | {'<>'}
                </a>
             

            
                <a
                  href="https://github.com/MRCODES/scorekeeperapp"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Code{'<>'}
                </a>
              
            </div>
          </article>



          {/*BMR*/}

          <article class="three_box">
            <div id="works-described">
              <h3>BMR App</h3>

           
              <br></br>

              <h5>
               Built a sleek, user-friendly weight management app with React and CSS, 
            helping users track and manage their weight more effectively. It provides 
            personalized calculations based on gender, allows quick data resets, 
              and offers a smooth, visually appealing experience that makes maintaining 
              a healthier lifestyle easier and more engaging.
              </h5>
            </div>
 <p><b>Click below to see code and app:</b> </p> 
            <div id="works-btns">
              
                <a
                  href="https://bmr-calc.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Site{" "} | {'<>'}
                </a>
              

              
                <a
                  href="https://github.com/MRCODES/BMR-Calculator"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Code{'<>'}
                </a>
              
            </div>
          </article>

    
        </div>{" "}
        {/*End Apps*/}






        <h2>Websites</h2>
        <div id="websites">
          {/*YOGA*/}

          <article class="five_box">
            <div id="works-described">
              <h3>Yoga Dojo Website Template</h3>
         
           

              <br></br>

              <h5>
              Designed and developed a interactive yoga studio website template from scratch, 
          creating an engaging experience for visitors. Built with HTML, CSS, JavaScript, jQuery, and animations, 
          the site features a visually appealing design and 
          smooth interactive elements, helping users easily navigate 
            classes, schedules, and information while enjoying an immersive, user-friendly experience.
              </h5>
            </div>

                     <p><b>Click below to see code and app:</b> </p> 
                  
            <div id="works-btns">
              
                <a
                  href="https://yoga-dojo.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Site | {'<>'}
                </a>
              

              
                <a
                  href="https://github.com/MRCODES/well-yoga/tree/main/well-yoga-website-live"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Code{'<>'}
                </a>
              
            </div>
          </article>

          {/*COFFEE*/}
          <article class="six_box">
            <div id="works-described">
              <h3>Coffee Website Template</h3>

        
            

              <br></br>

              <h5>
               Created a coffee brand website from scratch using HTML, CSS, JavaScript, and jQuery, 
            providing visitors with a visually appealing and user-friendly experience.
              </h5>
            </div>

                   <p><b>Click below to see code and app:</b> </p> 
                  
            <div id="works-btns">
              
                <a
                  href="https://coffee-beans.netlify.app/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Site | {'<>'}
                </a>
              

              
                <a
                  href="https://github.com/MRCODES/coffee"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Code{'<>'}
                </a>
              
            </div>
          </article>

          {/*BAKERY*/}

          <article class="eight_box">
            <div id="works-described">
              <h3>Bakery Website Template</h3>

      
            

              <br></br>

              <h5>
             Created a bakery website using HTML, CSS, JavaScript, and jQuery, delivering a 
            visually appealing and user-friendly experience that reflects the brand’s charm.
              </h5>
            </div>
  <p><b>Click below to see code and app:</b> </p> 
            <div id="works-btns">
              
                <a
                  href="https://small-bakery.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Site | {'<>'}
                </a>
              

              
                <a
                  href="https://github.com/MRCODES/Anna-s-Bakery"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Code{'<>'}
                </a>
              
            </div>
          </article>
        </div>
        <h2>Adobe Designs</h2>
        <div id="designs">
          {/*ICE CREAM */}

          <article class="nine_box">
            <div id="works-described">
              <h3>Branding #1</h3>

              <h5>
                I creatively designed and illustrated a simple captivating ice cream shop logo.
                <br></br>
                <br></br>
              
              </h5>
            </div>
          </article>

          {/*TOWER*/}

          <article class="ten_box">
            <div id="works-described">
              <h3>Branding #2</h3>

              <h5>
                I created this logo as a tower company concept using only
                letters.
              </h5>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
